import React from 'react';
import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react';

const DomeCover: ComponentWithAs<'svg', IconProps> = (props: IconProps) => (
  <Icon viewBox='0 0 250 180' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M236.142 98.6535C242.164 113.78 245.19 129.962 245.05 146.278L244.982 146.277C244.719 163.402 189.863 176.806 122.358 176.227C54.7816 175.647 0.119353 161.273 0.266542 144.122C0.268013 143.951 0.274956 143.78 0.287331 143.609C0.498308 127.487 3.79831 111.559 10.0052 96.7128C16.2849 81.6922 25.4172 68.0736 36.8807 56.6345C48.3442 45.1954 61.9143 36.1598 76.8163 30.0436C91.7182 23.9274 107.66 20.8505 123.732 20.9884C139.804 21.1263 155.691 24.4764 170.485 30.8475C185.28 37.2185 198.693 46.4856 209.959 58.1198C221.224 69.754 230.121 83.5274 236.142 98.6535Z'
      fill='#9AC0A3'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M126.709 12.8814C131.704 12.1862 135.363 9.90913 135.387 7.17577C135.415 3.84742 130.042 1.10295 123.385 1.04582C116.729 0.988693 111.309 3.64055 111.281 6.9689C111.258 9.59773 114.605 11.8623 119.293 12.7262L119.183 25.5526C119.169 27.2093 120.5 28.564 122.157 28.5782L123.575 28.5904C125.231 28.6046 126.586 27.273 126.6 25.6162L126.709 12.8814Z'
      fill='#CECECE'
    />
  </Icon>
);

export default DomeCover;
